export const tratamentoDeErros = {
    methods: {

        getMessagesError(erro){
            console.table(erro)
            console.table(erro.response)
            var messages = [];
            if(erro.response){ // API respondeu
                if(erro.response.data.errors){
                    messages = this.addMessageError(erro.response.data.errors);//vários erros
                }else{ //apenas a mensagem de erro
                    if(erro.response.data.message){
                        messages = [{severity: 'error', content: erro.response.data.message}];
                    }else{
                        messages = [{severity: 'error', content: 'Um erro inesperado aconteceu! Tente novamente mais tarde.'}];
                    }
                }
            } else { //API não respondeu
                messages = [{severity: 'error', content: 'Sistema indisponível! Tente novamente mais tarde.'}];
                // this.$router.push({ name: "login" });
            }
            return messages;
        },

        getMessagesErrorLocalProva(erro){
            console.error(erro.response.data.errors);
            console.error(erro.response.data);

            var messages = [];

                messages = [{severity: 'error', content: 'Preencha os campos obrigatórios.'}];

            return messages;
        },

        addMessageError(errors){
            var messages = [];
            for (let error  of errors) {
                messages.push({severity: 'error', content: `${error.fieldName}:${error.message}`});
            }
            return messages;
        },

        addMessageError2(errors){
            var messages = [];
            for (let error  of errors) {
                messages.push({severity: 'error', content: `${error.field }:${error.defaultMessage}`});
            }
            return messages;
        }

    }
}
